import React from 'react';
import Box from '@ff/ui/Box';
import IconButton from '@ff/ui/IconButton';
import { IS_APP } from 'shared/lib/pathUtils';
import { styled } from '@ff/ui';
import setSafeAreaInsetTop from 'shared/lib/setSafeAreaInsetTop';
import { getHandlerByKey } from 'shared/lib/appHandlers';
import { isWeChatBrowser } from 'shared/lib/useragentdetection';

export default function BackNavigation() {
  // Don't render if not in app or if in WeChat browser
  if (!IS_APP || isWeChatBrowser()) return null;

  return (
    <Container>
      <IconButton
        icon='ff-icon-arrow_back_ios'
        iconProps={{ fontSize: 22 }}
        color='white'
        width={50}
        onClick={() => {
          if (window.history.length > 1) {
            window.history.back();
          } else {
            getHandlerByKey('Close Webview')();
          }
        }}
      />
    </Container>
  )
}

const Container = styled(Box)({
  position: 'fixed',
  top: setSafeAreaInsetTop(),
  // disable tap highlight for APP
  WebkitTapHighlightColor: 'transparent',
  left: 15,
  zIndex: 100
});
